import { MapStore, MarkerLayerConfig, MarkerDataConfig, ClusterConfig } from "@/components/Map/stores/MapStore";
import { useLocalObservable } from "mobx-react-lite";

export function useMapStore<TData>(
	layerConfig?: MarkerLayerConfig,
	dataConfig?: MarkerDataConfig<TData>,
	clustering?: ClusterConfig,
) {
	return useLocalObservable(() => new MapStore<TData>(layerConfig, dataConfig, clustering));
}
